import React, { useContext, useCallback, useEffect } from 'react';
import { WalletContext } from '../context/WalletContext.js';
import { useWallet } from '@solana/wallet-adapter-react';
import { WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import '../styles/wallet.css';

const Wallet = () => {
  const { balance, error, updateBalance } = useContext(WalletContext);
  const { connected, publicKey } = useWallet();

  const handleRetry = useCallback(() => {
    if (connected && publicKey) {
      updateBalance();
    }
  }, [connected, publicKey, updateBalance]);

  useEffect(() => {
    if (connected && publicKey) {
      updateBalance();
    }
  }, [connected, publicKey, updateBalance]);

  return (
    <div className="wallet-container">
      <div className="wallet user-wallet">
        <WalletMultiButton />
        
      </div>
    
      
    </div>
  );
};

export default Wallet;
